// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    financialSituationModels: "Financial Situation Models",
    pageDescription: "Configure reusable field definitions for financial situation assessments",
    createModel: "Create Model",
  },
  nb_NO: {
    settings: "Innstillinger",
    financialSituationModels: "Økonomiske situasjonsmodeller",
    pageDescription:
      "Konfigurer gjenbrukbare feltdefinisjoner for økonomiske situasjonsvurderinger",
    createModel: "Opprett modell",
  },
} as const;
